import './scss/index.scss';
import ComponentsFactory from '../../foundation/components-factory';
import SIFantasyGamesComponent from './js/si-fantasy-games.component';

ComponentsFactory.getInstance().define('si-fantasy-games', SIFantasyGamesComponent);
